import setLocalAdmins from './setLocalAdmins';
import deactivateLocalAdmin from './deactivateLocalAdmin';
import activateLocalAdmin from './activateLocalAdmin';
import setLocalAdmin from './setLocalAdmin';
import archiveLocalAdmin from './archiveLocalAdmin';
import restoreLocalAdmin from './restoreLocalAdmin';

export default {
  setLocalAdmins,
  activateLocalAdmin,
  restoreLocalAdmin,
  deactivateLocalAdmin,
  setLocalAdmin,
  archiveLocalAdmin,
};
